$(function () {
  $('.checkedDownloadList .checkboxLabel input').change(function () {
    var confirmUrl = $(this).closest('.checkedDownloadList').attr('data-confirmLink');
    var targets = $(
      '.downloads table:not(.clone) a, .downloads ul:not(.clone) li a',
      $(this).closest('.checkedDownloadList')
    );
    var hint = $(this).closest('.checkedDownloadList').find('.hint');
    if (this.checked) {
      $.ajax({
        url: confirmUrl,
      }).done(function (data) {
        hint.remove();
        $('.checkedDownloadList .checkmark').css('border', '1px solid #1E325F');
        var links = data.trim().split(';');
        if (links.length == targets.length) {
          targets.each(function (i) {
            $(this).attr('href', links[i]);
          });
        }
      });
    } else {
      targets.each(function () {
        $(this).attr('href', '');
      });
    }
  });
  $('.checkedDownloadList .downloads a').click(function (e) {
    if ($(this).attr('href') == undefined || $(this).attr('href') == '') {
      e.preventDefault();
      e.stopPropagation();
      if (!$(this).closest('.checkedDownloadList').find('.hint').length) {
        $(this)
          .closest('.checkedDownloadList')
          .find('.checkboxContainer')
          .append(
            '<div class="hint">' +
              $(this).closest('.checkedDownloadList').find('.downloads').attr('data-message') +
              '</div>'
          );
        $(this)
          .closest('.checkedDownloadList')
          .find('.checkmark')
          .css('border', '1px solid #FF0000');
      }
    }
  });
});
